import { render, staticRenderFns } from "./iconForm.vue?vue&type=template&id=95fa32c8&scoped=true&"
import script from "./iconForm.vue?vue&type=script&lang=js&"
export * from "./iconForm.vue?vue&type=script&lang=js&"
import style0 from "./iconForm.vue?vue&type=style&index=0&id=95fa32c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fa32c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95fa32c8')) {
      api.createRecord('95fa32c8', component.options)
    } else {
      api.reload('95fa32c8', component.options)
    }
    module.hot.accept("./iconForm.vue?vue&type=template&id=95fa32c8&scoped=true&", function () {
      api.rerender('95fa32c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/components/iconForm.vue"
export default component.exports